import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'
import LineaSVG from '../assets/images/LineaCurvaAvisoLegal.svg'
import LineaMobileSVG from '../assets/images/LineaCurvaMobileAvisoLegal.svg'
import { sizes } from '../utils/breakpoints'
import { useMediaQuery } from 'react-responsive'
import Seo from '../components/Seo'

const AvisoLegal = () => {
  const isMobile = useMediaQuery({ maxWidth: sizes.mobile })
  const linea = isMobile ? LineaMobileSVG : LineaSVG

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <Seo
        title="Aviso Legal"
        description="Aviso legal de TARTIS: condiciones de uso y titularidad del sitio web."
        path="/aviso-legal"
      />
      <Title>Aviso Legal</Title>
      <ImgLinea src={linea} alt="" />
      <SectionInfo>
        <TitleSection>Titularidad del sitio web</TitleSection>
        <InfoSection>
          En cumplimiento de lo dispuesto en la Ley 34/2002, de 11 de julio, de
          Servicios de la Sociedad de la Información y del Comercio Electrónico
          (LSSI-CE), se informa de los siguientes datos identificativos del
          titular del sitio web:
        </InfoSection>
        <ContainerList>
          <ListInfo>
            Nombre o denominación social: <b>TARTIS</b> Technologies SL
          </ListInfo>
          <ListInfo>CIF/NIF: B19831023</ListInfo>
          <ListInfo>
            Domicilio social: Calle Julián Camarillo, número 7, 4.º izquierda, Madrid.
          </ListInfo>
          {/* <ListInfo>
            Teléfono de contacto:{' '}
            <Enlaces href="tel:910798368"> 910 79 83 68</Enlaces>
          </ListInfo> */}
          <ListInfo>
            Correo electrónico de contacto:
            <Enlaces href="mailto:info@tartis.io"> info@tartis.io</Enlaces>
          </ListInfo>
        </ContainerList>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>Objeto del sitio web</TitleSection>
        <InfoSection>
          El presente sitio web tiene como finalidad proporcionar información
          sobre los servicios ofrecidos por <b>TARTIS</b>, una consultora
          especializada en transformación digital. Ayudamos a las empresas a
          desarrollar soluciones tecnológicas personalizadas, escalables y
          adaptadas a sus necesidades. Nuestro trabajo abarca desde la
          conceptualización de ideas hasta el diseño, desarrollo y ejecución de
          estrategias digitales, incluyendo servicios en la nube y asesoramiento
          en innovación tecnológica. <br></br>El acceso a este sitio web y sus
          contenidos es gratuito, pero implica que has leído y aceptas este
          Aviso Legal, así como nuestra Política de Privacidad y Política de
          Cookies. Si no estás conforme con ellas, por favor, no utilices este
          sitio web ni los servicios que ofrecemos a través de él.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>Condiciones de uso</TitleSection>
        <InfoSection>
          Nos reservamos el derecho de denegar, suspender, interrumpir o
          cancelar el acceso o la utilización, total o parcialmente, del sitio
          web a aquellos usuarios que incumplan las condiciones establecidas en
          este Aviso Legal, nuestras Políticas de Privacidad o cualquier
          normativa aplicable. <br></br>Podemos incluir en nuestro sitio web
          materiales como artículos, estudios y descripciones de proyectos con
          fines informativos. Nos reservamos el derecho de modificar, actualizar
          o eliminar estos materiales en cualquier momento sin previo aviso.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>Propiedad intelectual e industrial</TitleSection>
        <InfoSection>
          El sitio web y todos sus contenidos (estructura, diseño gráfico,
          código fuente, marcas, nombres comerciales, signos distintivos,
          textos, imágenes y productos) están protegidos por derechos de
          propiedad intelectual e industrial titularidad de <b>TARTIS</b> o de
          terceros autorizados. <br></br>El acceso o uso del sitio web no
          implica la renuncia, transmisión, licencia ni cesión total o parcial
          de dichos derechos. Queda estrictamente prohibida cualquier
          reproducción, transformación, distribución, comunicación pública o
          cualquier forma de explotación de los contenidos del sitio web sin la
          autorización previa y expresa de <b>TARTIS</b>.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>Uso permitido del sitio web</TitleSection>
        <InfoSection>
          El usuario se compromete a utilizar el sitio web y sus contenidos de
          forma adecuada y a no llevar a cabo actividades como las siguientes:
        </InfoSection>
        <ContainerList>
          <ListInfo>
            Publicar comunicaciones comerciales no autorizadas.
          </ListInfo>
          <ListInfo>
            CIntroducir o difundir virus o código malintencionado.
          </ListInfo>
          <ListInfo>
            Acceder a cuentas de otros usuarios sin autorización.
          </ListInfo>
          <ListInfo>
            Realizar actos que alteren, inutilicen o dañen datos o sistemas de{' '}
            <b>TARTIS</b> o de terceros.
          </ListInfo>
          <ListInfo>
            Realizar actividades contrarias a la ley, la moral o el orden
            público.
          </ListInfo>
        </ContainerList>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>Exclusión de responsabilidad</TitleSection>
        <InfoSection>
          <b>TARTIS</b> no garantiza la disponibilidad, continuidad ni
          infalibilidad del sitio web y sus contenidos. No seremos responsables
          de interrupciones en el servicio, errores en los contenidos o daños
          derivados del uso de este sitio web.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>Enlaces a terceros</TitleSection>
        <InfoSection>
          El sitio web puede contener enlaces a sitios web de terceros.{' '}
          <b>TARTIS</b> no controla ni se responsabiliza de los contenidos de
          estos sitios. La presencia de dichos enlaces no implica aprobación,
          recomendación ni relación con las entidades propietarias de los
          mismos. alteración.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>Legislación aplicable y jurisdicción</TitleSection>
        <InfoSection>
          El uso de este sitio web se rige por la legislación española.
          Cualquier controversia que surja en relación con el uso del sitio web
          será sometida a la jurisdicción de los Juzgados y Tribunales de la
          ciudad de Madrid, salvo que la normativa aplicable disponga lo
          contrario.
        </InfoSection>
      </SectionInfo>

      <SectionInfo>
        <TitleSection>Contacto</TitleSection>
        <InfoSection>
          Si tienes alguna duda sobre este Aviso Legal o nuestras Políticas de
          Privacidad, puedes ponerte en contacto con nosotros enviando un correo
          electrónico a<Mail href="mailto:info@tartis.io"> info@tartis.io</Mail>
          .
        </InfoSection>
      </SectionInfo>
    </Container>
  )
}

export default AvisoLegal

const Container = styled.div`
  margin-bottom: 70px;
`

const Title = styled.h1`
  padding: 158px 0 0 230px;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 40px;
  line-height: 48px;
  color: ${({ theme }) => theme.colors.text.primary};

  @media (max-width: ${sizes.mobile}px) {
    padding: 70px 0 0 30px;
    font-size: 15px;
    line-height: 18px;
  }
`

const ImgLinea = styled.img`
  width: 100%;
  max-width: 100%;
  height: auto;
`

const SectionInfo = styled.div`
  padding: 50px 293px 0 230px;
  margin-bottom: 30px;
  @media (max-width: ${sizes.mobile}px) {
    padding: 20px 40px 0 30px;
  }
`

const TitleSection = styled.p`
  font-family: 'fuenteNegrita';
  font-size: 24px;
  line-height: 28.8px;

  @media (max-width: ${sizes.mobile}px) {
    font-size: 13px;
    line-height: 15.6px;
  }
`
const InfoSection = styled.span`
  font-family: 'fuenteRegularMont';
  font-size: 20px;
  line-height: 24.38px;

  @media (max-width: ${sizes.mobile}px) {
    font-size: 12px;
    line-height: 14.63px;
  }
`

const ListInfo = styled.li`
  font-family: 'fuenteRegularMont';
  font-size: 20px;
  line-height: 24.38px;
  margin-bottom: 5px;

  &::marker {
    font-size: 0.7em; /* Ajusta el tamaño del marcador */
  }

  @media (max-width: ${sizes.mobile}px) {
    font-size: 12px;
    line-height: 14.63px;
  }
`

const ContainerList = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 5px;
`

const Mail = styled.a`
  font-family: 'fuenteNegritaMont';
  color: inherit;
  text-decoration: none;
`

const Enlaces = styled.a`
  font-family: 'fuenteRegularMont';
  color: inherit;
  text-decoration: none;
`
